module.exports = {"522326001":"王母街道","522326002":"平洞街道","522326003":"新屯街道","522326101":"乐元镇","522326102":"打易镇","522326103":"乐旺镇","522326104":"桑郎镇","522326105":"麻山镇","522326107":"石屯镇","522326108":"蔗香镇","522326109":"郊纳镇","522326110":"大观镇","522326111":"边饶镇","522326112":"昂武镇","522326206":"油迈瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522326.json
// module id = 2319
// module chunks = 0